import { combineReducers } from 'redux';
import {
  AUTHENTICATE_USER,
  UNAUTHENTICATE_USER,
  LOGIN_WITH_TOKEN,
  SEND_MAGIC_LINK,
  FETCH_GUEST_SIGN_UP,
  FETCH_UPDATE_USER_LANGUAGE,
} from '../actions/index';
import storage from '../lib/storage';

const authenticationSession = (state = {}, action) => {
  switch (action.type) {
    case AUTHENTICATE_USER:
    case FETCH_GUEST_SIGN_UP:
    case LOGIN_WITH_TOKEN:
      return {
        token: action.payload.accessToken,
      };
    case SEND_MAGIC_LINK:
      return {};
    case UNAUTHENTICATE_USER:
      return {};
    default:
      return state;
  }
};

const setLanguage = (state, action) => {
  const { type, payload } = action;
  const auth = storage.getItem('auth');
  let language;

  if (type === FETCH_UPDATE_USER_LANGUAGE) {
    language = payload;
  } else {
    language = (payload.languageCode || 'en');
  }

  if (auth) {
    auth.languageCode = language;
    storage.setItem('auth', auth);
  }

  storage.setItem('language', language);

  return language;
};

const currentLanguage = (state = 'en', action) => {
  switch (action.type) {
    case FETCH_UPDATE_USER_LANGUAGE:
    case LOGIN_WITH_TOKEN:
    case AUTHENTICATE_USER:
      return setLanguage(state, action);

    default:
      return state;
  }
};

export default combineReducers({
  authentication: authenticationSession,
  language: currentLanguage,
});



// WEBPACK FOOTER //
// ./src/reducers/session.reducer.js